import FooterQuestionnaire from '@/components/layout-questionnaire/components/footer/footer';
import NavigationBar from '@/components/layout/navigation-bar/navigation-bar';
import Layout from '@/components/layout-questionnaire/layout-questionnaire';
import { Flex, ProgressBar, Text } from '@cmpsr/components';
import ProgressStepList from './components/progress-step-list';
import { QuestionnaireLoadingProps } from './types';

export default function QuestionnaireLoading({
  isFirstTimeLoadingResults,
  isCalculationComplete,
}: QuestionnaireLoadingProps) {
  return (
    <Layout background="gradient-04" flex="1">
      <NavigationBar beta />
      <Flex
        as="main"
        pt={{ base: 'spacer-8', lg: 'spacer-12', xl: 'spacer-16' }}
        px={{ base: 'spacer-5', lg: 'spacer-12', xl: 'spacer-16' }}
        flexDirection="column"
        alignItems="flex-start"
        flexGrow="1"
        width="fit-content"
        margin="auto"
        background="none"
      >
        <Text variant="text-header-2XL" color="text-light">
          {isFirstTimeLoadingResults ? (
            <>
              We are{' '}
              <Text as="span" textStyle="text-header-2xl-v" color="text-light">
                analyzing{' '}
              </Text>
              your results
            </>
          ) : (
            <>
              Your risk score is{' '}
              <Text as="span" textStyle="text-header-2xl-v" color="text-light">
                recalibrating
              </Text>
            </>
          )}
        </Text>
        <Text variant="text-body-regular" color="text-light" mt="spacer-2">
          Please do not close this browser window or press the back button
        </Text>
        <ProgressBar
          isIndeterminate
          variant="default"
          width="100%"
          color="background-page-02"
          size="xs"
          mt={{ base: 'spacer-9', lg: 'spacer-12' }}
          mb={{ base: 'spacer-14', lg: 'spacer-16' }}
        />
        <ProgressStepList
          isFirstTimeLoadingResults={isFirstTimeLoadingResults}
          isCalculationComplete={isCalculationComplete}
        />
      </Flex>
      <FooterQuestionnaire />
    </Layout>
  );
}
